import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DatePicker } from "src/core/components/custom-ui/date-picker";
import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { IMission } from "src/core/hooks/folder/useFolderMissions";
import { useRenewMission } from "src/core/hooks/folder/useRenewMission";

type RenewMissionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  mission: IMission | null;
  setMissionToEdit: (mission: IMission | null) => void;
};

export default function RenewMissionModal({
  open,
  setOpen,
  mission,
  setMissionToEdit,
}: RenewMissionModalProps) {
  const { t } = useTranslation();

  const { form, onSubmit, isLoading } = useRenewMission(setOpen, mission, setMissionToEdit);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="modal-renew-mission"
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="modal-add-stakeholder-header">
          <DialogTitle>{t("renewMission.modal.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("renewMission.modal.description")}
          </DialogDescription>
        </DialogHeader>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="font-medium uppercase mb-5">{t("form.renewMission.missionType")}</div>
            <div className="font-light">{mission?.missionType}</div>
            <div className="w-1/2 mt-20">
              <div>
                <DatePicker
                  name="renewDate"
                  required
                  label={t("form.renewMission.missionDate")}
                  className="w-full"
                  control={form.control}
                  allowFutureDates={true}
                  allowPastDates={false}
                  minDate={new Date()}
                />
              </div>
            </div>
            <DialogFooter>
              <Button type="submit" variant="default" className="ml-[20px]" loading={isLoading}>
                {t("form.renewMission.submit")}
              </Button>
              <Button
                variant="link"
                onClick={(event) => {
                  event.preventDefault();
                  setOpen(false);
                  setMissionToEdit(null);
                }}
              >
                {t("global.form.cancel")}
              </Button>
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
